<div class="unsubscribe-container">
  <div class="unsubscribe-card">
    @if (isSuccess()) {
      <div class="success-state">
        <div class="icon-wrapper success">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <h2>{{ 'UNSUBSCRIBE_REMINDERS.successTitle' | translate }}</h2>

        <p class="info">{{ successMessage() }}</p>

        <p class="credit-note">
          {{ validityNote() }}
        </p>

        <app-button
          [label]="'UNSUBSCRIBE_REMINDERS.returnHome' | translate"
          buttonStyle="outlined"
          (click)="router.navigate(['/'])"
          [fullWidth]="true"
        ></app-button>
      </div>
    }

    @if (isError() && !isSuccess()) {
      <div class="error-state">
        <div class="icon-wrapper error">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        </div>

        <h2>{{ 'UNSUBSCRIBE_REMINDERS.errorTitle' | translate }}</h2>

        <p class="error-message">
          {{ errorMessage() }}
        </p>

        <app-button
          [label]="'UNSUBSCRIBE_REMINDERS.returnHome' | translate"
          buttonStyle="outlined"
          (click)="router.navigate(['/'])"
          [fullWidth]="true"
        ></app-button>
      </div>
    }

    @if (!isSuccess() && !isError()) {
      <div>
        <h2>{{ 'UNSUBSCRIBE_REMINDERS.title' | translate }}</h2>

        <p class="info description">
          {{ unsubscribeDescription() }}
        </p>

        <form [formGroup]="unsubscribeForm" (ngSubmit)="onUnsubscribe()">
          <div class="flex flex-column align-items-start justify-content-center">
            @if (reminderType() === 'unknown') {
              <label class="ml-2" for="reason">
                {{ 'UNSUBSCRIBE_REMINDERS.email' | translate }}
              </label>

              <app-input
                name="email"
                type="email"
                [control]="unsubscribeForm.controls.email"
                class="mb-3"
              ></app-input>
            }

            <label class="ml-2" for="reason">
              {{ 'UNSUBSCRIBE_REMINDERS.reasonLabel' | translate }}
            </label>

            <textarea
              id="reason"
              name="reason"
              formControlName="reason"
              class="w-full note"
              rows="4"
            ></textarea>
          </div>

          <p class="credit-note">
            <strong>
              {{ 'UNSUBSCRIBE_REMINDERS.notePrefix' | translate }}
            </strong>
            {{ validityNote() }}
          </p>

          <app-button
            [label]="buttonLabel()"
            [fullWidth]="true"
            [disabled]="isLoading()"
            (click)="onUnsubscribe()"
          ></app-button>
        </form>
      </div>
    }
  </div>
</div>
